import { Injectable } from '@angular/core';

import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../authentication/services/authentication.service';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class JwtInterceptorService implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService, private oAuthService: OAuthService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        const currentUser = this.authenticationService.getCurrentUser();
        const currentToken = this.oAuthService.getAccessToken();
        // Bypassing currentUser obj check for the sack of IE11 doesn't init it when redirect back from Auth0
        if (currentUser && currentToken) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${currentToken}`
                }
            });
        }

        return next.handle(request);
    }
}
